import React from 'react';
import { FaNewspaper, FaEnvelope, FaImages, FaTrophy, FaPlus, FaCamera, FaArrowRight, FaGraduationCap } from 'react-icons/fa';
import './DashboardOverview.css';
import TrafficWidget from './TrafficWidget';

const DashboardOverview = ({ stats, recentActivity, onQuickAction, greeting }) => {
    return (
        <div className="dashboard-overview">
            <div className="dashboard-header">
                <h2>{greeting}, Admin!</h2>
                <p>Berikut adalah ringkasan aktivitas website sekolah hari ini.</p>
            </div>

            {/* Stats Cards */}
            <div className="stats-grid">
                <div className="stat-card blue">
                    <div className="stat-icon">
                        <FaNewspaper />
                    </div>
                    <div className="stat-info">
                        <h3>{stats.beritaCount}</h3>
                        <p>Total Berita</p>
                    </div>
                </div>

                <div className="stat-card green">
                    <div className="stat-icon">
                        <FaEnvelope />
                    </div>
                    <div className="stat-info">
                        <h3>{stats.unreadPesanCount} <small>({stats.pesanCount})</small></h3>
                        <p>Pesan Baru</p>
                    </div>
                </div>

                <div className="stat-card purple">
                    <div className="stat-icon">
                        <FaImages />
                    </div>
                    <div className="stat-info">
                        <h3>{stats.galleryCount}</h3>
                        <p>Foto Galeri</p>
                    </div>
                </div>

                <div className="stat-card orange">
                    <div className="stat-icon">
                        <FaTrophy />
                    </div>
                    <div className="stat-info">
                        <h3>{stats.prestasiCount}</h3>
                        <p>Prestasi</p>
                    </div>
                </div>

                <div className="stat-card cyan">
                    <div className="stat-icon">
                        <FaGraduationCap />
                    </div>
                    <div className="stat-info">
                        <h3>{stats.alumniLulusCount || 0}</h3>
                        <p>Alumni Lulus</p>
                    </div>
                </div>
            </div>

            {/* Traffic Widget */}
            <TrafficWidget />

            <div className="dashboard-columns">
                {/* Quick Actions */}
                <div className="dashboard-column left">
                    <div className="dashboard-panel">
                        <h3>Akses Cepat</h3>
                        <div className="quick-actions-grid">
                            <button className="quick-action-btn" onClick={() => onQuickAction('add-news')}>
                                <div className="icon-circle"><FaPlus /></div>
                                <span>Tulis Berita</span>
                            </button>
                            <button className="quick-action-btn" onClick={() => onQuickAction('manage-gallery')}>
                                <div className="icon-circle"><FaCamera /></div>
                                <span>Upload Foto</span>
                            </button>
                            <button className="quick-action-btn" onClick={() => onQuickAction('check-messages')}>
                                <div className="icon-circle"><FaEnvelope /></div>
                                <span>Cek Pesan</span>
                            </button>
                        </div>
                    </div>
                </div>

                {/* Recent Activity */}
                <div className="dashboard-column right">
                    <div className="dashboard-panel">
                        <h3>Aktivitas Terbaru</h3>
                        {recentActivity && recentActivity.length > 0 ? (
                            <ul className="recent-activity-list">
                                {recentActivity.map((item, index) => (
                                    <li key={item.id || index} className="activity-item">
                                        <div className="activity-icon-wrapper">
                                            {item.icon}
                                        </div>
                                        <div className="activity-content">
                                            <h4>{item.title}</h4>
                                            <p>{item.desc}</p>
                                        </div>
                                        <div className="activity-time">
                                            {new Date(item.time).toLocaleDateString('id-ID', { day: 'numeric', month: 'short' })}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p className="empty-text">Belum ada aktivitas tercatat.</p>
                        )}
                        <button className="view-all-link" onClick={() => onQuickAction('all-activity')}>
                            Lihat Semua Aktivitas <FaArrowRight />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DashboardOverview;
